function makePreview(page) {
  var vp = page.getViewport(1);
  var canvas = document.createElement("canvas");
  if(vp.height > vp.width){
  	canvas.height = 600;
    canvas.width = canvas.height * (vp.width / vp.height);
  } else {
    canvas.width = 4125;
    canvas.height = canvas.width * (vp.height / vp.width);
  }
  var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
  return page.render({canvasContext: canvas.getContext("2d"), viewport: page.getViewport(scale)}).promise.then(function () {
    return canvas;
  });
}

function makeThumbnail(page) {
  var vp = page.getViewport(1);
  var canvas = document.createElement("canvas");
  if(vp.height > vp.width){
  	canvas.height = vp.height;
    canvas.width = canvas.height * (vp.width / vp.height);
  } else {
    canvas.width = vp.width;
    canvas.height = canvas.width * (vp.height / vp.width);
  }
  var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
  return page.render({canvasContext: canvas.getContext("2d"), viewport: page.getViewport(scale)}).promise.then(function () {
    return canvas;
  });
}

function processPDF(fileReader) {
  console.log(fileReader);
  var typedarray = new Uint8Array(fileReader.result);

  var { pdfjsLib } = globalThis;

  // The workerSrc property shall be specified.
  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.shopify.com/s/files/1/0088/8006/2579/files/pdf.worker.mjs?v=1711479215';

  // Asynchronous download of PDF
  var loadingTask = pdfjsLib.getDocument(fileReader.result);
  loadingTask.promise.then(function(pdf) {
    console.log('PDF loaded');

    // Fetch the first page
    var pageNumber = 1;
    pdf.getPage(pageNumber).then(function(page) {
      console.log('Page loaded');

      var scale = 1.5;
      var viewport = page.getViewport({scale: scale});

      // Prepare canvas using PDF page dimensions
      var canvas = document.getElementById('the-canvas');
      var context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render PDF page into canvas context
      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      var renderTask = page.render(renderContext);
      renderTask.promise.then(function () {
        var previewImageElem = document.querySelector(".sm-preview");
        previewImageElem.src = canvas.toDataURL();
          $(".product-single__photo" + ":not('.hide') > img").hide();

          var enlargedPreview = document.querySelector(".lg-preview");
          enlargedPreview.src = canvas.toDataURL();

          //Code to store generated image as base64 encoded image order line item property
          var imagePreviewString = document.querySelector("#img-preview-string");
          if(imagePreviewString) {
            var imageString = canvas.toDataURL('image/jpeg', 0.1);
            var linkString = "http://" + imageString.slice(imageString.indexOf(";") + 1)
            imagePreviewString.value = linkString;
            hideLoadingDiv();
          }
        console.log('Page rendered');
      });
    });
  }, function (reason) {
    // PDF loading error
    console.error(reason);
  });
  // pdfjsLib.getDocument(typedarray).promise.then(function (doc) {
  //   var pages = []; while (pages.length < doc.numPages) pages.push(pages.length + 1);
  //   return Promise.all(pages.map(function (num) {
  //     // create a div for each page and build a small canvas for it
  //     var div = document.querySelector(".product-featured-img");
  //     if(div) {
  //       div = div.parentNode;  
  //     }
  //     return doc.getPage(num).then(makePreview).then(function (canvas) {
        
  //       doc.getPage(num).then(makeThumbnail).then(function (newCanvas) {
          
  //         var previewImageElem = document.querySelector(".sm-preview");
  //         if(previewImageElem) {          
		// 	if(canvas.height > canvas.width) {
  //             $(".sm-preview").css('max-height', '530px');
  //             $(".sm-preview").css('max-width', '50%');
  //             $(".sm-preview").css('margin-left', "10%");
  //             $(".product-single__description").css('margin-top', '50%');
  //           } else {
  //             $(".sm-preview").css('max-height', '295px');
  //             $(".sm-preview").css('max-width', '530px');
  //             $(".sm-preview").css('margin-left', "0");
  //             $(".product-single__description").css('margin-top', '5%');
  //           }
  //           previewImageElem.src = canvas.toDataURL();
  //           $(".product-single__photo" + ":not('.hide') > img").hide();

  //           var enlargedPreview = document.querySelector(".lg-preview");
  //           enlargedPreview.src = canvas.toDataURL();

  //           //Code to store generated image as base64 encoded image order line item property
  //           var imagePreviewString = document.querySelector("#img-preview-string");
  //           if(imagePreviewString) {
  //             var imageString = newCanvas.toDataURL('image/jpeg', 0.1);
  //             var linkString = "http://" + imageString.slice(imageString.indexOf(";") + 1)
  //             imagePreviewString.value = linkString;
  //             hideLoadingDiv();
  //           }
  //         }
        
  //       });
  //     });
  //   }));
  // }).catch(console.error);
  
};

function handleFile() {  
  //Upon new upload default the image preview input string in case we don't need it
  var imagePreviewString = document.querySelector("#img-preview-string");
  if(imagePreviewString) {
    imagePreviewString.value = "";
  }
  
  var file = this.files[0];
  var fileReader = new FileReader();
  
  var formFilename = document.querySelector("#filename");
  if(file && formFilename) {
    //show loading div
    showLoadingDiv();
    
    //console.log("File uploaded: " + file.name);
  	formFilename.value = file.name;
  }
   
  switch(file.type) {
    case "application/pdf":            
      fileReader.onload = function() {
        processPDF(this);
      };      

      fileReader.readAsArrayBuffer(file);     
      break;
    default:
	  fileReader.onload = function(e) {
        var previewImage = document.querySelector(".sm-preview");
        var enlargedPreview = document.querySelector(".lg-preview");
            
        var img = new Image();       
        img.onload = function(){
          if(img.width > img.height){
          	$(".sm-preview").css('max-height', '295px');
            $(".sm-preview").css('max-width', '530px');
            $(".sm-preview").css('margin-left', "0");
            $(".product-single__description").css('margin-top', '5%');
          } else {
          	$(".sm-preview").css('max-height', '530px');
            $(".sm-preview").css('max-width', '40%');
            $(".sm-preview").css('margin-left', "20%");
            $(".product-single__description").css('margin-top', '30%');
          }
        };
        img.src = e.target.result;
        
        $(".product-single__photo" + ":not('.hide') > img").hide();         
        previewImage.src = e.target.result;
        enlargedPreview.src = e.target.result;
        
        hideLoadingDiv();
      };      

      fileReader.readAsDataURL(file);    
      break;
  }
  document.getElementById("deleteImage").style.display = 'block';
}

//Used to determine if we have already started framework initialisation on slow devices
var previewImgLoaded = false;

function initiatePreviewFramework() {
  if(!previewImgLoaded) {
    previewImgLoaded = true;
    var previewImage = createPreviewImage();
    var featureImage = document.querySelector(".product-featured-img")
    var featureImageSize = "";

    if(featureImage) {
      featureImageSize = featureImage.getBoundingClientRect();
    }

    if(previewImage) {
      previewImage.addEventListener('click', function() {
        openPreviewLarge();           
      });
    

      //Create loading div
      var loadingDiv = document.createElement("div");
      loadingDiv.classList.add("loading-div");
      loadingDiv.innerHTML = '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';


      //Create preview modal
      var enlargedPreview = previewImage.cloneNode();
      enlargedPreview.id = "";
      enlargedPreview.className = "";
      enlargedPreview.classList.add("lg-preview");

      var previewContainer = document.createElement("div");
      previewContainer.classList.add("lg-preview-container");
      previewContainer.appendChild(enlargedPreview);


      var modal = document.createElement("div");
      modal.classList.add("preview-modal-overlay");
      modal.appendChild(previewContainer);

      modal.addEventListener('click', closePreviewLarge);

      var closeButton = document.createElement("a");
      closeButton.classList.add("close-symbol");          

      closeButton.addEventListener('click', closePreviewLarge);

      previewContainer.appendChild(closeButton);

      document.body.appendChild(modal);


      var div = document.querySelector(".product-featured-img");

      if(div) {
       	div = div.parentNode.parentNode.parentNode;
        div.appendChild(previewImage);
        div.appendChild(loadingDiv);
      }
    }
  }  
}

function showLoadingDiv() {
  var loadingDiv = document.querySelector(".loading-div");
  if(loadingDiv) {
    loadingDiv.style.display = "block";
  }
  
  var previewImage = document.querySelector(".sm-preview");
  if(previewImage) {
    previewImage.style.display = "none";
  }
}

function hideLoadingDiv() {
  var loadingDiv = document.querySelector(".loading-div");
  if(loadingDiv) {
    loadingDiv.style.display = "none";
  }
  
  var previewImage = document.querySelector(".sm-preview");
  if(previewImage) {
    previewImage.style.display = "block";
  }
}

function showImgLoadingDiv(inId) {
  var loadingDiv = document.querySelector("#loadingDiv" + inId);
  if(loadingDiv) {
    loadingDiv.style.display = "block";
  }
}

function hideImgLoadingDiv(inId) {
  var loadingDiv = document.querySelector("#loadingDiv" + inId);
  if(loadingDiv) {
    loadingDiv.style.display = "none";
  }
}

function createPreviewImage() {
  var productFeatureImage = document.querySelector(".product-featured-img");
  var previewImage = "";
  if(productFeatureImage) {
    previewImage = productFeatureImage.cloneNode();
    previewImage.setAttribute("data-srcset", "");
    previewImage.setAttribute("srcset", "");
    previewImage.classList.add("sm-preview");
  	previewImage.style.display = "none";
    previewImage.src = "";
  }  
  
  return previewImage;
}

function openPreviewLarge() {  
  document.querySelector(".preview-modal-overlay").style.display = "block";
  document.querySelector(".lg-preview").style.display = "block";
  document.querySelector(".lg-preview-container").style.display = "block";
  document.querySelector(".close-symbol").style.display = "block";
}

function closePreviewLarge() {
  document.querySelector(".preview-modal-overlay").style.display = "none";
  document.querySelector(".lg-preview").style.display = "none";
  document.querySelector(".lg-preview-container").style.display = "none";
  document.querySelector(".close-symbol").style.display = "none";
}

function openCartPreview(inSrc) {
  var lgPreviewImg = document.getElementById("lgPreviewImage");
  if(lgPreviewImg) {
  	lgPreviewImage.src = inSrc;
    openPreviewLarge();
  }
}

function cloneCanvas(oldCanvas) {

    //create a new canvas
    var newCanvas = document.createElement('canvas');
    var context = newCanvas.getContext('2d');

    //set dimensions
    newCanvas.width = oldCanvas.width;
    newCanvas.height = oldCanvas.height;

    //apply the old canvas to the new one
    context.drawImage(oldCanvas, 0, 0);

    //return the new canvas
    return newCanvas;
}

function attachPreviewHandler() {
  var uploaderyForm = document.querySelector('form[data-uploadery]');
  if(uploaderyForm) {
    var inputElement = uploaderyForm.querySelector('input');
    if(inputElement) {
      inputElement.onchange = handleFile;
    }
  }
}

function attachLoadingDivHandler() {
  var uploaderyContainer = document.querySelector('#uploadery-container');
  
  if(uploaderyContainer) {
    var config = { childList: true };

    var observer = new MutationObserver(loadingDivHandler);

    observer.observe(uploaderyContainer, config);
  }
}

function loadingDivHandler() {
  var uploaderyContainer = document.querySelector('#uploadery-container');

  if(uploaderyContainer) {
    if(document.querySelector(".uploaderyProgressBar")) {
      showLoadingDiv();
    }
  }
}

function addLargeImageModal() {  
  //Create preview modal
  var enlargedPreview = document.createElement("img");
  enlargedPreview.id = "lgPreviewImage";
  enlargedPreview.className = "";
  enlargedPreview.classList.add("lg-preview");

  var previewContainer = document.createElement("div");
  previewContainer.classList.add("lg-preview-container");
  previewContainer.appendChild(enlargedPreview);


  var modal = document.createElement("div");
  modal.classList.add("preview-modal-overlay");
  modal.appendChild(previewContainer);

  modal.addEventListener('click', closePreviewLarge);

  var closeButton = document.createElement("a");
  closeButton.classList.add("close-symbol");          

  closeButton.addEventListener('click', closePreviewLarge);

  previewContainer.appendChild(closeButton);

  document.body.appendChild(modal);
}

function getURLFromString(inString) {
  var urlString = inString.replace(/\r?\n|\r/g,"").replace(" ","");

  var pattern = new RegExp(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/, 'gi');
  var res = pattern.exec(urlString);
  if(res) {
    return res[0];
  }
  
  return null;
}

function processCartDetails() {
  var cartRows = document.querySelectorAll(".cart__row");
  
  var imageWrapperResults = null;
  var imageWrapper = null;
  
  var cartThumbnailResults = null;
  var cartThumbnail = null;
  
  var uploaderyURLResults = null;
  var uploaderyURL = null;
  var uploaderyFilename = null;
  
  var pdfGeneratedURL = null;
  
  var isPDF = false;
    
  if(cartRows && cartRows.length > 0) {
    for(var i = 0; i < cartRows.length; i++) {
      isPDF = false;
      var row = cartRows[i];      
      
      uploaderyURLResults = row.getElementsByClassName("uploadery-resrc-link");
            
      if(uploaderyURLResults && uploaderyURLResults.length > 0) {
        var uploaderyURLElement = uploaderyURLResults[0];
        uploaderyURL = getURLFromString(uploaderyURLElement.innerHTML);
        //console.log("URL: " + uploaderyURL);
      }
      
      imageWrapperResults = row.getElementsByClassName("cart__image-wrapper");
      
      if(imageWrapperResults && imageWrapperResults.length) {
        imageWrapper = imageWrapperResults[0];
        
        var images = imageWrapper.getElementsByTagName("img");
        
        //console.log(images);
        //console.log(uploaderyURL);
        
        if(images && images.length > 0 && uploaderyURL.indexOf("pdf") > 0) {
          try {           
            isPDF = true;
            pdfGeneratedURL = images[0].src;   
          } catch(e) {
            console.log("Error processing url: " + uploaderyURL + " " + e);  
          }
        }
      }
      
      cartThumbnailResults = row.getElementsByClassName("cart-thumbnail");
      
      if(cartThumbnailResults && cartThumbnailResults.length > 0) {
        cartThumbnail = cartThumbnailResults[0];
               
        if(isPDF) {
//           cartThumbnail.onclick = (function(URL) {
//             return function() {openCartPreview(URL)};
//           })(pdfGeneratedURL);
        } else {  
          cartThumbnail.onclick = (function(URL) {
            return function() {openCartPreview(URL)};
          })(uploaderyURL);
        }
      }
      
      //Reset URL and Thumbnail values
      cartThumbnail = null;
      uploaderyURL = null;
    }
  }
}

function processOrderCartThumbnails() {
  //Crude check to see if we are on the orders page
  if(window.location.href.indexOf("orders") > 0) {
    var cartThumbnailResults = document.getElementsByClassName("cart-thumbnail");
    
    if(cartThumbnailResults.length) {
      for(var i = 0; i < cartThumbnailResults.length; i++) {
        if(cartThumbnailResults && cartThumbnailResults.length > 0) {
          var cartThumbnail = cartThumbnailResults[i];
		  var URL = cartThumbnail.src;
          
          cartThumbnail.onclick = (function(inURL) {
            if(inURL.indexOf("//uploadery.s3") >= 0) {
            	inURL = inURL.replace("preview_", "");
            }
            return function() {openCartPreview(inURL)};
          })(URL);          
        }
      }
    }
  }
}

var pdfFiles = {};

//Try to add listener after page is loaded, otherwise once the form is loaded within the uploadery div
setTimeout(function() {
  attachPreviewHandler();
  initiatePreviewFramework();
  //attachLoadingDivHandler();
  
  var uploaderyContainer = document.querySelector('#uploadery-container');
  
  if(uploaderyContainer) {  
    uploaderyContainer.addEventListener("DOMNodeInserted", function() {
      //Remove event listener so the initiation functions are only called once
      document.querySelector('#uploadery-container').removeEventListener("DOMNodeInserted", this);    

      attachPreviewHandler();
      initiatePreviewFramework();
      //attachLoadingDivHandler();

    });
  } 
  
}, 2000);


//Listen for when the page loads then iterate through cart items to make image previews
document.addEventListener("DOMContentLoaded", function(){
  addLargeImageModal();
  processCartDetails();
  processOrderCartThumbnails();
});






